module.exports = __webpack_public_path__ + "media/images/background_home_2480-ac0f60ae.jpg";